import {
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress
} from "@mui/material";
import { useTranslation } from "react-i18next";

const UploadDialog = ({ open, handleClose, uploadProgress }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('progress')}</DialogTitle>
      <DialogContent>
        <LinearProgress variant="determinate" value={uploadProgress} />
        {uploadProgress && <p>{uploadProgress}% {t('complete')}</p>}
      </DialogContent>
    </Dialog>
  );
};

export default UploadDialog;
